// extracted by mini-css-extract-plugin
export default {"body":"body-dpcbo","header":"header-YDdOv","close":"close-bHaGV"};